//captcha init
var captchaWidgetId;

var partnerModalForm = (function () {
  var csrf_token;

  function init() {
    uiBindings();
  }

  var uiBindings = function () {
    var openPartnerModalForm = document.querySelectorAll(
      ".open-partner-modal-form"
    );

    for (var i = 0; i < openPartnerModalForm.length; i++) {
      openPartnerModalForm[i].addEventListener(
        "click",
        function (evt) {
          evt.preventDefault();

          loadRecaptchaForDemoModal(); // load recaptcha for webinar demo form

          captchaWidgetId = undefined;

          var modalContainer = document.querySelector(".partners-modal-section");
          if (modalContainer) {
            partnerModal = new tingle.modal({
              focusAfterClosed: this,
              cssClass: ["partner-pop-up-form"],
              onClose: function () {
                //Close Event
                partnerModal.destroy();
              },
            });
            partnerModal.setContent(modalContainer.innerHTML);
            partnerModal.open();

            //form initialise
            partnerModalFormInit();

            // event on form load
            if ((document.querySelector('.tingle-modal #partner-modal-email-id').value === '')
              && (document.querySelector('.tingle-modal #partner-modal-name').value === '')
              && (this.classList.contains('custom-btn-amp-events'))) {
              WebEventTracker.logEvent(EDS.webEvents, "LoadPartnerForm", {
                action: "Register as a partner",
                partner: "Partner Main Form",
              });
            }
          }
        },
        false
      );
    }
  };

  function partnerModalFormInit() {
    // Set the page URL hidden field with page url value
    var getCurrentPageURL = window.location.href,
      intS = 0,
      getPageURLInput = document.getElementById("partner-modal-page-url"),
      partnerAuthenticityToken = document.getElementById("authenticity_token");

    if (csrf_token !== '') {
      partnerAuthenticityToken.value = csrf_token;
    }

    if (getPageURLInput) {
      getPageURLInput.value = getCurrentPageURL.trim();
    }

    // render recaptcha for modal form
    var eTime = setInterval(function () {
      if (captchaWidgetId == undefined) {
        captchaWidgetId = renderPartnerCaptchaField();
      }

      if (++intS >= 30 || captchaWidgetId) { clearInterval(eTime); }
    }, 100);

    var emailField = document.getElementById("form-email");
    if (emailField) {
      //focus
      emailField.addEventListener("focus", function () {
        var that = this,
          emailError = document.getElementById("partner-email-error");

        //remove existing error
        if (emailError) {
          emailError.remove();
        }

        that.classList.remove("error-border");

        if (!csrf_token) {
          // XHR request for user token
          bsLib.ajax(
            "GET",
            bsLib.railsHost() + "/user/token.json",
            {},
            false,
            {},
            // Success message for user token.
            function (data) {
              var dataRequest = bsLib.JSONParse(data.response);
              csrf_token = dataRequest.csrf_token;
              var partnerAuthenticityToken = document.getElementById("authenticity_token");
              partnerAuthenticityToken.value = csrf_token;
            },
            // Custom Error message for user token.
            function () {
              return "user token not working";
            }
          );
        }
      });
      //blur
      emailField.addEventListener("blur", function (event) {
        var validEmail = true,
          that = this,
          submitBtn = document.getElementById("partner-submit-btn"),
          emailError = document.getElementById("partner-email-error");

        //false valid dataset
        that.dataset.notvalid = "0";

        //remove existing error
        if (emailError) {
          emailError.remove();
        }

        // render recaptcha for modal form
        if (!captchaWidgetId) {
          captchaWidgetId = renderPartnerCaptchaField();
        }

        if (
          that.value.trim().length == 0 ||
          !bsLib.validEmail(that.value.trim())
        ) {
          validEmail = false;

          that.classList.add("error-border");
          that.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="partner-email-error">' +
              (that.value.trim().length == 0
                ? Messages.salesAndSupportPage.noemail
                : Messages.salesAndSupportPage.invalidEmail) +
              "</span>"
          );
        } else {
          that.classList.remove("error-border");
        }

        if (validEmail) {
          //Disable submit button
          if (submitBtn) {
            submitBtn.setAttribute("disabled", "disabled");
            submitBtn.value = Messages.salesAndSupportPage.validateText;
          }

          bsLib.ajax(
            "GET",
            bsLib.railsHost() +
              "/marketing_api/check_email_validation?email=" +
              encodeURIComponent(that.value.trim()),
            {},
            true,
            {
              "X-CSRF-Token": csrf_token,
              "content-type":
                "application/x-www-form-urlencoded; charset=utf-8", // Setting content type.
            },
            function (data) {
              var dataRequest = bsLib.JSONParse(data.response);

              //remove disable
              if (submitBtn) {
                submitBtn.removeAttribute("disabled");
                submitBtn.value = submitBtn.dataset.btntext;
              }

              if (dataRequest.valid === false) {
                that.dataset.notvalid = "1";

                that.classList.add("error-border");
                if (
                  that.parentNode.getElementsByClassName("error-message")
                    .length === 0
                ) {
                  that.insertAdjacentHTML(
                    "afterend",
                    '<span class="error-message" id="partner-email-error">' +
                      Messages.salesAndSupportPage.invalidEmail +
                      "</span>"
                  );
                }
              }
            },
            function () {}
          );
        }
      });
    }
  }

  function loadRecaptchaForDemoModal() {
    var captchaField = document.getElementById("recaptcha-js");
    if (!captchaField && typeof grecaptcha === "undefined") {
      var scriptElm = document.createElement("script");
      scriptElm.setAttribute("id", "recaptcha-js");
      scriptElm.setAttribute("type", "text/javascript");
      scriptElm.setAttribute(
        "src",
        "https://www.google.com/recaptcha/api.js?ver=1.0"
      );
      scriptElm.setAttribute("defer", "defer");
      document.body.appendChild(scriptElm);
    }
  }

  init();
})();

function renderPartnerCaptchaField() {
  //remove captcha
  var captchaWidget,
    modalTingle = document.getElementById("tingle-modal-box"),
    captchaFieldShow = document.querySelector(".g-recaptcha.show"),
    captchaField = document.getElementById("partnerformcaptcha");
  //remove all grecaptcha from dom
  if (captchaFieldShow && typeof grecaptcha !== "undefined") {
    if (captchaFieldShow.innerHTML !== "") {
      captchaFieldShow.innerHTML = "";
    }
  }

  //recaptcha render from JS
  if (
    typeof grecaptcha !== "undefined" &&
    typeof grecaptcha.render !== "undefined" &&
    captchaField.childNodes.length === 0
  ) {
    captchaWidget = grecaptcha.render(captchaField, {
      sitekey: captchaField.dataset.sitekey,
      theme: "light",
      badge: "bottomleft",
      size: "invisible",
      callback: function () {
        return partnerModalFormValidation(captchaWidget);
      },
    });

    modalTingle.dataset.gWidgetId = captchaWidget;
  } else if (typeof grecaptcha !== "undefined" &&
    captchaField.childNodes.length >= 0) {
    captchaWidget = modalTingle.dataset.gWidgetId;
  }
  return captchaWidget;
}

//form those have captcha
function partnerFormValidationCaptcha(captchaWidgetId) {
  var ContactForm = {};
  ContactForm.fnameField = document.getElementById("form-fname");
  ContactForm.lnameField = document.getElementById("form-lname");
  ContactForm.emailField = document.getElementById("form-email");
  ContactForm.companyField = document.getElementById("form-company");
  ContactForm.messageField = document.getElementById("form-message");

  // Error fields creation
  ContactForm.fnameError = document.getElementById("partner-fname-error");
  ContactForm.lnameError = document.getElementById("partner-lname-error");
  ContactForm.partnerModalEmailError = document.getElementById(
    "partner-email-error"
  );
  ContactForm.companyError = document.getElementById("partner-company-error");
  ContactForm.messageError = document.getElementById("partner-message-error");

  // render recaptcha for modal form
  if (!captchaWidgetId) {
    captchaWidgetId = renderPartnerCaptchaField();
  }
    
  function form_validation(
    fieldName,
    fieldError,
    idError,
    errorMessage,
    isEmail,
    isSelectBox,
    isPhoneNo,
    emailErrorMessage
  ) {
    if (fieldError) {
      fieldError.remove();
    }

    if (!isEmail && !isPhoneNo) {
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          if (isSelectBox) {
            fieldName.nextSibling.insertAdjacentHTML(
              "afterend",
              '<span class="error-message" id="' +
                idError +
                '">' +
                errorMessage +
                "</span>"
            );
            fieldName.nextSibling.classList.add("error-border");
          } else {
            fieldName.classList.add("error-border");
            fieldName.insertAdjacentHTML(
              "afterend",
              '<span class="error-message" id="' +
                idError +
                '">' +
                errorMessage +
                "</span>"
            );
          }
        } else {
          fieldName.classList.remove("error-border");
          if (isSelectBox) {
            fieldName.nextSibling.classList.remove("error-border");
          }
        }
      }
    } else if (isEmail) {
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              errorMessage +
              "</span>"
          );
        } else if (!bsLib.validEmail(fieldName.value.trim())) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              emailErrorMessage +
              "</span>"
          );
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    } else if (isPhoneNo) {  //for phone no validation
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              errorMessage +
              "</span>"
          );
        } else if (!bsLib.validPhoneNo(fieldName.value.trim())) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              Messages.phoneNoValidationErrors.invalidPhoneNo +
              "</span>"
          );
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    }
  }

  form_validation(
    ContactForm.fnameField,
    ContactForm.fnameError,
    "partner-fname-error",
    "Please share your first name",
    false,
    false,
    false
  );
  form_validation(
    ContactForm.lnameField,
    ContactForm.lnameError,
    "partner-lname-error",
    "Please share your last name",
    false,
    false,
    false
  );
  form_validation(
    ContactForm.emailField,
    ContactForm.partnerModalEmailError,
    "partner-email-error",
    "Please share your email address",
    true,
    false,
    false,
    "Please share your vaild email address"
  );
  form_validation(
    ContactForm.companyField,
    ContactForm.companyError,
    "partner-company-error",
    "Please share your business name",
    false,
    false,
    false
  );
  form_validation(
    ContactForm.messageField,
    ContactForm.messageError,
    "partner-message-error",
    "Please share your query",
    false,
    false,
    false
  );

  function contactform_field(field) {
    if (field) {
      return field.value.trim();
    }
    return false;
  }

  if (
    contactform_field(ContactForm.fnameField) === "" ||
    contactform_field(ContactForm.lnameField) === "" ||
    contactform_field(ContactForm.emailField) === "" ||
    !bsLib.validEmail(ContactForm.emailField.value.trim()) ||
    contactform_field(ContactForm.companyField) === "" ||
    contactform_field(ContactForm.messageField) === ""
  ) {
    return false;
  } else if (ContactForm.emailField.dataset.notvalid === "1") {
    //check valid email from rails api

    if (ContactForm.emailError) {
      ContactForm.emailError.remove();
    }

    ContactForm.emailField.classList.add("error-border");
    ContactForm.emailField.insertAdjacentHTML(
      "afterend",
      '<span class="error-message" id="partner-email-error">' +
        Messages.salesAndSupportPage.invalidWorkEmail +
        "</span>"
    );

    return false;
  } else {
    if (typeof grecaptcha !== "undefined") {
      grecaptcha.execute(captchaWidgetId);
    }
  }
  return false;
}

function partnerModalFormValidation(captchaWidgetId) {
  var ContactForm = {};
  ContactForm.fnameField = document.getElementById("form-fname");
  ContactForm.lnameField = document.getElementById("form-lname");
  ContactForm.emailField = document.getElementById("form-email");
  ContactForm.companyField = document.getElementById("form-company");
  ContactForm.messageField = document.getElementById("form-message");
  
  // Error fields creation
  ContactForm.fnameError = document.getElementById("partner-fname-error");
  ContactForm.lnameError = document.getElementById("partner-lname-error");
  ContactForm.partnerModalEmailError = document.getElementById(
    "partner-email-error"
  );
  ContactForm.companyError = document.getElementById("partner-company-error");
  ContactForm.messageError = document.getElementById("partner-message-error");

  function form_validation(
    fieldName,
    fieldError,
    idError,
    errorMessage,
    isEmail,
    isSelectBox,
    isPhoneNo,
    emailErrorMessage
  ) {
    if (fieldError) {
      fieldError.remove();
    }

    if (!isEmail && !isPhoneNo) {
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          if (isSelectBox) {
            fieldName.nextSibling.insertAdjacentHTML(
              "afterend",
              '<span class="error-message" id="' +
                idError +
                '">' +
                errorMessage +
                "</span>"
            );
            fieldName.nextSibling.classList.add("error-border");
          } else {
            fieldName.classList.add("error-border");
            fieldName.insertAdjacentHTML(
              "afterend",
              '<span class="error-message" id="' +
                idError +
                '">' +
                errorMessage +
                "</span>"
            );
          }
        } else {
          fieldName.classList.remove("error-border");
          if (isSelectBox) {
            fieldName.nextSibling.classList.remove("error-border");
          }
        }
      }
    } else if (isEmail) {
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              errorMessage +
              "</span>"
          );
        } else if (!bsLib.validEmail(fieldName.value.trim())) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              emailErrorMessage +
              "</span>"
          );
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    } else if (isPhoneNo) {  //for phone no validation
      if (fieldName) {
        if (fieldName.value.trim() == "") {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              errorMessage +
              "</span>"
          );
        } else if (!bsLib.validPhoneNo(fieldName.value.trim())) {
          fieldName.classList.add("error-border");
          fieldName.insertAdjacentHTML(
            "afterend",
            '<span class="error-message" id="' +
              idError +
              '">' +
              Messages.phoneNoValidationErrors.invalidPhoneNo +
              "</span>"
          );
        } else {
          fieldName.classList.remove("error-border");
        }
      }
    }
  }

  form_validation(
    ContactForm.fnameField,
    ContactForm.fnameError,
    "partner-fname-error",
    "Please share your first name",
    false,
    false,
    false
  );
  form_validation(
    ContactForm.lnameField,
    ContactForm.lnameError,
    "partner-lname-error",
    "Please share your last name",
    false,
    false,
    false
  );
  form_validation(
    ContactForm.emailField,
    ContactForm.partnerModalEmailError,
    "partner-email-error",
    "Please share your email address",
    true,
    false,
    false,
    "Please share your vaild email address"
  );
  form_validation(
    ContactForm.companyField,
    ContactForm.companyError,
    "partner-company-error",
    "Please share your business name",
    false,
    false,
    false
  );
  form_validation(
    ContactForm.messageField,
    ContactForm.messageError,
    "partner-message-error",
    "Please share your query",
    false,
    false,
    false
  );

  function contactform_field(field) {
    if (field) {
      return field.value.trim();
    }
    return false;
  }

  if (
    contactform_field(ContactForm.fnameField) === "" ||
    contactform_field(ContactForm.lnameField) === "" ||
    contactform_field(ContactForm.emailField) === "" ||
    !bsLib.validEmail(ContactForm.emailField.value.trim()) ||
    contactform_field(ContactForm.companyField) === "" ||
    contactform_field(ContactForm.messageField) === ""
  ) {
    return false;
  } else if (ContactForm.emailField.dataset.notvalid === "1") {
    //check valid email from rails api

    if (ContactForm.emailError) {
      ContactForm.emailError.remove();
    }

    ContactForm.emailField.classList.add("error-border");
    ContactForm.emailField.insertAdjacentHTML(
      "afterend",
      '<span class="error-message" id="partner-email-error">' +
        Messages.salesAndSupportPage.invalidWorkEmail +
        "</span>"
    );

    return false;
  } else {
    var submitBtn = document.getElementById("partner-submit-btn"),
      partnerFormBlock = document.getElementById("partners-modal-form"),
      formPageUrl = document.getElementById("partner-modal-page-url"),
      contactformcaptcha = document.getElementById("partnerformcaptcha"),
      partnerFnameField = document.getElementById("form-fname"),
      partnerLnameField = document.getElementById("form-lname"),
      partnerEmailField = document.getElementById("form-email"),
      partnerRoleField = document.getElementById("form-role"),
      partnerPhoneField = document.getElementById("form-phone"),
      partnerMessageField = document.getElementById("form-message"),
      partnerCompanyField = document.getElementById("form-company"),
      partnerRequestType = document.getElementById("request_type"),
      partnerModalName = document.getElementById("partner-modal-name"),
      partnerEmailId = document.getElementById("partner-modal-email-id"),
      partnerUtf8 = document.getElementById("utf_no"),
      partnerAuthenticityToken = document.getElementById("authenticity_token");

    submitBtn.setAttribute("disabled", "disabled");
    submitBtn.value = submitBtn.dataset.btndisabled;

    var dataRequest = {
      first_name: partnerFnameField.value.trim(),
      last_name: partnerLnameField.value.trim(),
      role: partnerRoleField.value.trim(),
      phone: partnerPhoneField.value.trim(),
      email: partnerEmailField.value.trim(),
      message: partnerMessageField.value.trim(),
      company: partnerCompanyField.value.trim(),
      authenticity_token: partnerAuthenticityToken.value.trim(), 
      utf8: partnerUtf8.value, 
      request_type: partnerRequestType.value.trim(),
      partner_name: partnerModalName.value.trim(),
      partner_email: partnerEmailId.value.trim(),
      ga_cid: bsLib.GAClientID(),
      source: "wp_form",
      page_url: formPageUrl.value.trim(),
    };

    if (contactformcaptcha) {
      var grecaptchaResponse =
        typeof grecaptcha !== "undefined"
          ? grecaptcha.getResponse(captchaWidgetId)
          : "";

      dataRequest["g-recaptcha-response"] = grecaptchaResponse;

      if (grecaptchaResponse.length === 0) {
        new bsAlert({
          alertType: "error",
          timeout: 5000,
          text: Messages.salesAndSupportPage.noRecaptcha,
        });

        return false;
      }
    }

    //ajax request
    bsLib.ajax(
      "POST",
      bsLib.railsHost() + "/partners/contact",
      dataRequest,
      false,
      {
        "X-CSRF-Token" : partnerAuthenticityToken.value.trim(),
        "content-type" : "application/x-www-form-urlencoded; charset=UTF-8" // Setting content type.
      }, //request header
      // Success message for user token.
      function (data) {
        if (data.readyState === 4) {
          // event on successful submit
          WebEventTracker.logEvent(EDS.webEvents, "SubmitPartnerForm", {
            action: (partnerEmailId.value.trim() !== '') ? "Contact Partner" : "Register as a partner",
            partner: (partnerModalName.value.trim() !== '') ? partnerModalName.value.trim() : "Partner Main Form",
          });

          submitBtn.removeAttribute("disabled");
          submitBtn.value = submitBtn.dataset.btntext;

          var dataResponse = bsLib.JSONParse(data.response);
          if (dataResponse.success === true) {
            var customerEmail = partnerEmailField.value.trim();

            // ga event
            if (typeof ga !== "undefined") {
              ga('browserstack.send', 'event', {
                'eventCategory': 'Partners Contact Forms', 'eventAction': 'CtaClick', 'eventLabel': 'Submit'
              });
            }

            //reset form
            partnerFormBlock.reset();

            captchaWidgetId = undefined;

            //destroy form modal
            partnerModal.destroy();

            new bsAlert({
              alertType: "success",
              timeout: 5000,
              text: "<span class='bs-alert-check'></span>Request received! We will respond back shortly to " + customerEmail,
              showClose: false,
              showIcon: true,
              htmlMessage: true
            });
          } else {
            new bsAlert({
              alertType: "error",
              timeout: 5000,
              showClose: false,
              showIcon: true,
              text: "Form success failed",
            });
          }
        }
      },
      // Custom Error message for user token.
      function () {
        console.error("form success failed");
      }
    );
  }
  return false;
}